import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {HeadMiEmpresa} from '../miEmpresa/HeadMiEmpresa';
import {Solicitar} from '../CategoriasEmpresa/Solicitar';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {DocumentosMiEmpresa} from './DocumentosMiEmpresa';
import {HeadDocumentos} from './HeadDocumentos';

export const ContentBodyDocumentos = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;
	/* Using the useSessionStore hook to get the UsuarioContext from the session storage. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	const [FiltroNombre, setFiltroNombre] = useState('');
	const [FiltroFecha, setFiltroFecha] = useState(() => {
		// Obtén la fecha actual
		var fechaActual = new Date();
		// Resta un año a la fecha actual
		fechaActual.setFullYear(fechaActual.getFullYear() - 1);
		// Retornamos la fecha actual menos un año
		return fechaActual;
	});
	const [ListaArchivos, setListaArchivos] = useState([]);

	const [empresa, setEmpresa] = useState({
		idEmpresa: '-------',
		nombreEmpresa: 'nombreEmpresSa',
		nombreContactoEmpresa: 'nombreContactoEmpresa',
		apellidosContactoEmpresa: 'apellidosContactoEmpresa',
		constraseña: 'constraseña',
		repitaConstraseña: 'repitaConstraseña',
		telefono: '666666666',
		direccion: 'direccion',
		codigoPostal: 'codigoPostal',
		webEmpresa: 'webEmpresa',
		emailEmpresa: 'emailEmpresa',
		tamañoEmpresa: '0',
		shareCare: false,
		descripcionEmpresa: 'descripcionEmpresa',
		notasEmpresa: 'notasEmpresa',
	});
	/*
    
        const descargarArchivos = (documentos) => {
            let lista = [];
            documentos.map(doc => {
                axios(window.ipdirection+'documentoByEmpresaIMG/' + doc.id + '/', {
                    method: 'GET',
                    headers: {
                        "Authorization": "Bearer " + Usuario.access
                    },
                    responseType: 'blob'
                }).then((response) => {
                    lista.push({
                        archivo: URL.createObjectURL(response.data),
                        nombre: doc.nombre,
                        id: doc.id,
                    });
                })
            })
            setListaArchivos(lista);
        }
        */
	const getDatEmpresa = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'prestadorServicios/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			// Introduciomos los datos del presatador de servicios al usuario
			setEmpresa(response.data[0]);
			descargarDocumentos(response.data[0]);
		});
	};

	const getDocumento = (url) => {
		axios({
			method: 'get',
			url: window.ipdirection + '' + url + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				let lista = ListaArchivos;
				response.data.map((documento) => {
					axios({
						method: 'get',
						url: window.ipdirection + '' + url + '/' + documento.id + '/',
						headers: {
							Authorization: 'Bearer ' + Usuario.access,
						},
						responseType: 'blob',
					})
						.then((response) => {
							lista.push({
								archivo: URL.createObjectURL(response.data),
								nombre: documento.nombre,
								fecha: documento.fecha,
								id: documento.id,
								url: url
							});
							setListaArchivos([...lista]);
						})
						.catch((error) => {
							console.log(error);
						});
				});
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const descargarDocumentos = (empr) => {
		let lista = [];
		if (empr.is_sociedad) {
			getDocumento('documentosSeguroRC');
			getDocumento('documentosSociedadesCIF');
			getDocumento('documentosSociedadesRegistroIAE');
		} else {
			getDocumento('documentosSeguroRC');
			getDocumento('documentosAutonomosAltaSS');
			getDocumento('documentosAutonomosRegistroAutonomos');
			getDocumento('documentosAutonomosTitulacion');
		}
	};

	const [PararUseEffect, setPararUseEffect] = useState(false);
	useEffect(function () {
		if (PararUseEffect == false) {
			getDatEmpresa();
			setPararUseEffect(true);
		}
		//descargarDocumentos()
	});

	const [EstadoComparadorFecha, setEstadoComparadorFecha] = useState(true);
	const comparadorFecha = (a, b) => {
		if (EstadoComparadorFecha) {
			if (a.fecha < b.fecha) {
				return -1;
			}
			if (a.fecha > b.fecha) {
				return 1;
			}
			return 0;
		} else {
			if (a.fecha > b.fecha) {
				return -1;
			}
			if (a.fecha < b.fecha) {
				return 1;
			}
			return 0;
		}
	};
	const ordenarPorFecha = () => {
		let lista = ListaArchivos;
		lista.sort(comparadorFecha);
		setListaArchivos([...lista]);
		setEstadoComparadorFecha(!EstadoComparadorFecha);
		setEstadoComparadorNombre(true);
	};

	const [EstadoComparadorNombre, setEstadoComparadorNombre] = useState(true);
	const comparadorNombre = (a, b) => {
		if (EstadoComparadorNombre) {
			if (a.nombre < b.nombre) {
				return -1;
			}
			if (a.nombre > b.nombre) {
				return 1;
			}
			return 0;
		} else {
			if (a.nombre > b.nombre) {
				return -1;
			}
			if (a.nombre < b.nombre) {
				return 1;
			}
			return 0;
		}
	};
	const ordenarPorNombre = () => {
		let lista = ListaArchivos;
		lista.sort(comparadorNombre);
		setListaArchivos([...lista]);
		setEstadoComparadorNombre(!EstadoComparadorNombre);
		setEstadoComparadorFecha(true);
	};

	return (
		<>
			<MenuLateralAB
				seleccionado={3}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>
			<div className='derContentMiEmpresa'>
				<HeadDocumentos
					FiltroFecha={FiltroFecha}
					setFiltroFecha={setFiltroFecha}
					FiltroNombre={FiltroNombre}
					setFiltroNombre={setFiltroNombre}
				/>
				<DocumentosMiEmpresa
					ListaArchivos={ListaArchivos}
					ordenarPorNombre={ordenarPorNombre}
					ordenarPorFecha={ordenarPorFecha}
					EstadoComparadorFecha={EstadoComparadorFecha}
					EstadoComparadorNombre={EstadoComparadorNombre}
					empresa={empresa}
					FiltroNombre={FiltroNombre}
					setFiltroNombre={setFiltroNombre}
					FiltroFecha={FiltroFecha}
				/>
			</div>
		</>
	);
};
